/* eslint-disable react/no-unescaped-entities */
import React, {
  useState,
  useEffect,
  useContext,
  forwardRef,
  useRef,
} from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PhoneIcon from '@mui/icons-material/Phone';
import SmsIcon from '@mui/icons-material/Sms';
import InputAdornment from '@mui/material/InputAdornment';
import { IMaskInput } from 'react-imask';
import Swal from 'sweetalert2';
import { getStorage, setStorage } from '../utils/functions/localstorage';
import { PassportAuth } from '../contexts/AuthContext';
import Loading from '../components/Loading';
import api from '../utils/functions/api';
import { useSearchParams } from 'react-router-dom';
import { swalErrorBtn, swalErrorTimer } from '../helpers/swalHelper';
import onelogo from '../assets/images/oneplatform.png'
import inetlogo from '../assets/images/Inet_logo.png'
import { useParams } from "react-router-dom";
import NotFound from '../components/NotFound/NotFound';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { FormControl, IconButton, InputLabel, OutlinedInput } from '@mui/material';
import AuthenticateApi from '../service/auth.api';
import SHA256 from 'crypto-js/sha256';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="000-0000000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      // eslint-disable-next-line react/destructuring-assignment
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
}
function TextMaskCustomOTP(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="000000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      // eslint-disable-next-line react/destructuring-assignment
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
}
// TextMaskCustom.propTypes = {
//   name: PropTypes.string.isRequired,
// };

// TextMaskCustomOTP.propTypes = {
//   name: PropTypes.string.isRequired,
// };

const ForwardedTextMaskCustom = forwardRef(TextMaskCustom);
const ForwardedTextMaskCustomOTP = forwardRef(TextMaskCustomOTP);


ForwardedTextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
};
ForwardedTextMaskCustomOTP.propTypes = {
  name: PropTypes.string.isRequired,
};


function Login() {
  const inputRef = useRef(null);
  const { handleSignin, handleSigninWithPWD } = useContext(PassportAuth);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState(false);
  const [mobileNo, setMobileNo] = useState('');
  const [otp, setOtp] = useState('');
  const [ref, setRef] = useState('');
  const [errorPhone, setErrorPhone] = useState(false);
  const [errorOTP, setErrorOTP] = useState(false);
  const [readOnlyField, setReadOnlyField] = useState(false);
  const [searchParams] = useSearchParams();
  const merchantUuid = searchParams.get('id')
  const [otpTimer, setOtpTimer] = useState(300);
  const [showPassword, setShowPassword] = useState(false);
  const { merchantPath } = useParams(); // รับค่าจาก path
  const [merchantExists, setMerchantExists] = useState(null); 

  useEffect(() => {
    setToken(!!getStorage('token'));
    return () => {};
  }, []);

  useEffect(() => {
    let timer;
    if (ref !== '' && otpTimer > 0) {
      timer = setInterval(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    }
    if (otpTimer === 0) {
      setRef('');
      setOtp('');
      setOtpTimer(300);
      setReadOnlyField(false);
      swalErrorBtn({title: 'OTP หมดอายุแล้ว'});
    }
    return () => clearInterval(timer);
  }, [ref, otpTimer]);

  // console.log('token', token);

  const schema = yup.object().shape({
    username: yup
    .string()
    .required('กรุณากรอกชื่อผู้ใช้'),
    password: yup
    .string()
    .required('กรุณากรอกรหัสผ่าน'),
  })

  const { register, handleSubmit, formState: {errors} } = useForm({
    resolver: yupResolver(schema)
  });

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };
  
  const checkMerchant = async () => {
    try {
      const resp = await AuthenticateApi.checkMerchantApi(merchantPath);
      setMerchantExists(resp.data?.isExists);
    } catch (error) {
      console.log("error", error);
      setMerchantExists(false)
    }
  }

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      const username = data.username.replace(/\s+/g, '');
      const password = data.password.replace(/\s+/g, '');
      // const hashPassword = SHA256(password).toString();
      
      const payload = {
        username: username,
        password: password,
        urlPath: merchantPath
      }
      const resp = await handleSigninWithPWD(payload);

      if (resp.success) {
        window.setTimeout(() => {
          window.location.reload();
          navigate('/');
        }, 2000);
      }

      switch (resp.result) {
        case 'The user credentials were incorrect.':
          swalErrorBtn({title: 'ข้อมูลผู้ใช้ไม่ถูกต้อง'});
          setIsLoading(false);
          break;

        default:
          break;
      }
    } catch (error) {
      console.error(error);
      swalErrorBtn({title: 'เข้าสู่ระบบไม่สำเร็จ'});
      setIsLoading(false);
    }
  }

  const handleLoginWithOneID = async () => {
    try {
      
      const resp = await AuthenticateApi.loginWithOneId();
      // console.log(resp)
    } catch (error) {
      console.log(error)
    }
  }

  const handleChangeErrorPhone = (event) => {
    const inputValue = event.target.value;
    setMobileNo(inputValue);
    // ตรวจสอบว่าความยาวของตัวเลขเป็น 10 ตัว
    if (inputValue.length !== 11) {
      setErrorPhone(true);
    } else {
      setErrorPhone(false);
    }
  };

  const handleChangeErrorOTP = (event) => {
    const inputValue = event.target.value;
    setOtp(inputValue);
    // ตรวจสอบว่าความยาวของตัวเลขเป็น 10 ตัว
    if (inputValue.length !== 6) {
      setErrorOTP(true);
    } else {
      setErrorOTP(false);
    }
  };

  const handleOnClickOTP = async () => {
    try {
      if (errorPhone === false) {
        const newMobileNo = mobileNo.replace(/-/g, '');
        const { data } = await api.post(
          `${process.env.REACT_APP_API_URL}/auth/login-citizen-mobileno`,
          {
            mobileNo: newMobileNo,
          },
        );

        setRef(data.ref);
      } else {
        Swal.fire({
          title: 'กรุณาใส่เบอร์โทรศัพท์ให้ครบ',
          icon: 'warning',
          confirmButtonColor: '#4FA893',
          confirmButtonText: 'ตกลง',
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOnClickLogin = async () => {
    try {
      if (errorOTP === false) {
        setIsLoading(true);
        const newMobileNo = mobileNo.replace(/-/g, '');
        // console.log('newMobileNo', newMobileNo);
        // console.log("merchantUuid : ", merchantUuid);
        const res = await handleSignin(newMobileNo, otp, ref, merchantUuid);
        // console.log('res', res);
        if (res.success) {
          window.setTimeout(() => {
            window.location.reload();
            navigate('/');
          }, 2000);
        }
        // setIsLoading(false);
        console.log('res.result.message', res);
        switch (res.result.message) {
          case 'invalid OTP':
            Swal.fire({
              title: 'เลข OTP ไม่ถูกต้อง',
              icon: 'error',
              confirmButtonColor: '#4FA893',
              confirmButtonText: 'ตกลง',
            });
            setIsLoading(false);
            break;
          case 'Account IS NOT ACTIVE':
            Swal.fire({
              title: 'เข้าสู่ระบบไม่สำเร็จ',
              icon: 'error',
              confirmButtonColor: '#4FA893',
              confirmButtonText: 'ตกลง',
            });
            setIsLoading(false);
            break;
          case 'Account Not Found':
            Swal.fire({
              title: 'เข้าสู่ระบบไม่สำเร็จ',
              icon: 'error',
              confirmButtonColor: '#4FA893',
              confirmButtonText: 'ตกลง',
            });
            setIsLoading(false);
            break;

          default:
            break;
        }
      } else {
        Swal.fire({
          title: 'กรุณาใส่เลข OTP ให้ครบ',
          icon: 'warning',
          confirmButtonColor: '#4FA893',
          confirmButtonText: 'ตกลง',
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: 'เข้าสู่ระบบไม่สำเร็จ',
        icon: 'error',
        confirmButtonColor: '#4FA893',
        confirmButtonText: 'ตกลง',
      });
      setIsLoading(false);
    }
  };

  const handleKeyPressOTP = (event) => {
    if (event.key === 'Enter') {
      handleOnClickOTP();
    }
  };
  const handleKeyPressLogin = (event) => {
    if (event.key === 'Enter') {
      handleOnClickLogin();
    }
  };
  
  useEffect(() => {
    const token = getStorage('token');
    if(merchantPath && !token) {
      setStorage("merchantPath", merchantPath)
    }
  }, [merchantPath])

  useEffect(() => {
    checkMerchant();
  }, [merchantPath])

  useEffect(() => {
    if (ref !== '') {
      setReadOnlyField(true);
    } else {
      setReadOnlyField(false);
    }
  }, [ref]);

  // if (merchantExists === null) {
  //   return <Loading isLoading={true} />;
  // }
  
  if (merchantExists === false) {
    return <NotFound />;
  }

  return token ? (
    <Navigate to="/" />
  ) : (
    <div
      style={{
        // background: '#4FA893',
        background: 'linear-gradient(to left top, #bcfbc5, #aff5c3, #a3eec0, #96e8be, #8ae1bc, #81dab8, #78d3b3, #6fccaf, #67c3a8, #5fbaa1, #57b19a, #4fa893)',
      }}
    >
      <Loading isLoading={isLoading} />
      {/* <CssBaseline /> */}
      <div className="flex h-screen">
        <div className="m-auto">
          <div className="px-6 py-4">
            <Card
              sx={{
                // height: 550,
                borderRadius: 2,
                padding: 2,
                position: 'relative',
                boxShadow:
                  '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
              }}
            >
              <Box
                sx={{
                  maxWidth: 400,
                  padding: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <img src={inetlogo} alt="inet logo" className='w-[140px] mb-6'/>
                <span className='mb-2'>ยินดีต้อนรับเข้าสู่ระบบ</span>
                <Typography component="h1" variant="h5" sx={{ fontWeight: 'medium' }} className='text-[#4FA893]'>
                  Bill Payment Lite
                </Typography>
                <Box noValidate sx={{ mt: 4 }} component="form" onSubmit={handleSubmit(onSubmit)}>
                  <TextField
                    fullWidth
                    {...register("username")}
                    error={!!errors.username}
                    helperText={errors.username?.message}
                    id="outlined-basic"
                    label="ชื่อผู้ใช้"
                    required
                    variant="outlined"
                    placeholder="ชื่อผู้ใช้"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <FormControl variant="outlined" required fullWidth sx={{ mt: 2 }}>
                    <InputLabel htmlFor="outlined-adornment-password">รหัสผ่าน</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={showPassword ? 'text' : 'password'}
                      required
                      {...register("password")}
                      error={!!errors.password}
                      helperText={errors.password?.message}
                      startAdornment={
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={
                              showPassword ? 'hide the password' : 'display the password'
                            }
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            onMouseUp={handleMouseUpPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="รหัสผ่าน"
                      placeholder='รหัสผ่าน'
                    />
                    {errors.password && <p className='text-red-600 flex justify-start text-xs p-2'>{errors.password?.message}</p>}
                  </FormControl>
                  {/* <Typography sx={{ mb: 1 }}>เข้าสู่ระบบผ่าน OTP</Typography>
                  <TextField
                    label="เบอร์โทรศัพท์"
                    variant="outlined"
                    margin="normal"
                    id="number"
                    required
                    fullWidth
                    autoFocus
                    value={mobileNo}
                    placeholder="000-0000000"
                    error={errorPhone}
                    helperText={errorPhone ? 'โปรดป้อนตัวเลข 10 ตัว' : ''}
                    InputProps={{
                      inputComponent: ForwardedTextMaskCustom,
                      inputRef,
                      onChange: handleChangeErrorPhone,
                      readOnly: readOnlyField,
                      startAdornment: (
                        <InputAdornment position="start">
                          <PhoneIcon />
                        </InputAdornment>
                      ),
                    }}
                    onKeyDown={handleKeyPressOTP}
                  /> */}

                  {/* {ref !== '' && (
                    <TextField
                      label="เลข OTP"
                      margin="normal"
                      required
                      fullWidth
                      autoFocus
                      id="otpnumber"
                      value={otp}
                      error={errorOTP}
                      helperText={errorOTP ? 'โปรดป้อนตัวเลข 6 ตัว' : ''}
                      InputProps={{
                        inputComponent: ForwardedTextMaskCustomOTP,
                        onChange: handleChangeErrorOTP, // handle onChange event
                        startAdornment: (
                          <InputAdornment position="start">
                            <SmsIcon />
                          </InputAdornment>
                        ),
                      }}
                      onKeyDown={handleKeyPressLogin}
                    />
                  )} */}

                  {/* {ref !== '' && (
                    <span className='text-xs text-slate-600 flex gap-1'>
                      รหัส OTP จะหมดอายุใน <p className='text-red-500'>{Math.floor(otpTimer / 60)}:{String(otpTimer % 60).padStart(2, '0')} </p> นาที
                    </span>
                  )} */}

                  <Button
                    type='submit'
                    fullWidth
                    variant='contained'
                    sx={{ borderRadius: 5, mt: 4, height: '42px', color: '#FFF', textTransform: 'none' }}
                  >
                    เข้าสู่ระบบ
                    {/* Sign In */}
                  </Button>

                  {/* <Button
                    onClick={() => handleLoginWithOneID()}
                    fullWidth
                    variant='outlined'
                    sx={{ borderRadius: 5, mt: 2, height: '42px', textTransform: 'none' }}
                  >
                    <img src={onelogo} alt="one" className="w-5 mx-2" />
                    เข้าสู่ระบบด้วย ONE ID
                  </Button> */}

                  <div className='flex justify-between mt-4'>
                    <a  href='https://one.th/type_forgot_password' target='_blank' className=' text-xs text-blue-500 underline'>ลืมรหัสผ่าน?</a>
                    <span className='text-xs text-[#4FA893]'> 
                      ยังไม่มีบัญชีใช่หรือไม่ ?
                      <a className='underline text-blue-500 ml-1 hover: cursor-pointer' onClick={() => navigate(`/register/${merchantPath}`)} >
                        ลงทะเบียนที่นี่
                      </a>
                    </span>
                  </div>

                  {/* {ref === '' && (
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 3, mb: 2 }}
                      onClick={handleOnClickOTP}
                    >
                      <div className="text-white">รับ OTP</div>
                    </Button>
                  )} */}
                  {/* {ref !== '' && (
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      disabled={otp.length < 6}
                      sx={{ mt: 3, mb: 2 }}
                      onClick={handleOnClickLogin}
                    >
                      <div className="text-white">ยืนยันรหัส OTP</div>
                    </Button>
                  )} */}
                  {/* {ref !== '' && (
                    <Button
                      type="submit"
                      fullWidth
                      color='error'
                      variant="contained"
                      sx={{ mb: 2 }}
                      onClick={() => {
                        window.location.reload();
                      }}
                    >
                      <div className="text-white">ยกเลิกส่ง OTP</div>
                    </Button>
                  )} */}
                </Box>
              </Box>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
